// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useTheme } from '@mui/material/styles';
import NavContext from './Navigation/NavContext';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({ style = {} }) => {
	const theme = useTheme();

	return (
		<SimpleBar
			sx={{
				height: '100%',
				// borderTop: `1px solid ${theme.palette.border}`,
				backgroundColor: theme.palette.background.drawer,
				...style,
				'& .simplebar-content': {
					display: 'flex',
					flexDirection: 'column',
				},
			}}
		>
			<NavContext />
			<Navigation />
		</SimpleBar>
	);
};

export default DrawerContent;
